import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OurServiceService } from '../../services/our-service.service';
import { OurServiceModel } from '../../models/service.model';

@Component({
    selector: 'service-details',
    templateUrl: 'service-details.component.html',
    styleUrls: ['service-details.component.scss']
})
export class ServiceDetailsComponent implements OnInit {
Id = 0;
currentLang = localStorage.getItem('lang') || 'ar';
      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true;
  constructor(private route: ActivatedRoute,private ourServicesService: OurServiceService){
     this.Id = +route.snapshot.paramMap.get("Id")!;
  }
service:OurServiceModel = {};
  ngOnInit(): void {
        if(this.Id > 0){
  this.ourServicesService.getById(this.Id).subscribe((res: any) => {
        this.service = res;
       
      });
    }
  }

}
